import AsianArt from "../../images/clients/asian-art-platform-logo 1.png";
import aws from "../../images/clients/aws-logo 1.png";
import bandai from "../../images/clients/bandai-namco 1.png";
import canon from "../../images/clients/canon-logo 1.png";
import columbia from "../../images/clients/columbia_threadneedle_investments 1.png";
import digipen from "../../images/clients/digipen-logo 1.png";
import lefistyle from "../../images/clients/eightx-lifestyle 1.png";
import village from "../../images/clients/enabling-village 1.png";
import ica from "../../images/clients/ica-logo 1.png";
import jaeger from "../../images/clients/jaegar-lecoultre-logo_ 1.png";

export const CanvasClients = [
  {
    id: 1,
    src: AsianArt,
    alt: "Asian Art logo",
  },
  {
    id: 2,
    src: aws,
    alt: "aws logo",
  },
  {
    id: 3,
    src: bandai,
    alt: "bandai logo",
  },
  {
    id: 4,
    src: canon,
    alt: "canon logo",
  },
  {
    id: 5,
    src: columbia,
    alt: "columbia logo",
  },
  {
    id: 6,
    src: digipen,
    alt: "digipen logo",
  },
  {
    id: 7,
    src: lefistyle,
    alt: "lefistyle logo",
  },
  {
    id: 8,
    src: village,
    alt: "village logo",
  },
  {
    id: 9,
    src: ica,
    alt: "ica logo",
  },
  {
    id: 10,
    src: jaeger,
    alt: "jaeger logo",
  },
];



// WEBPACK FOOTER //
// ./src/page/canvas/canvas-clients.js